export enum ProfessionTypes {
  GETALL = '@profession/GETALL',
  GETALL_SUCCESS = '@profession/GETALL_SUCCESS',
  GETALL_FAILED = '@profession/GETALL_FAILED',
  SETUP_PROFESSION = '@profession/SETUP_PROFESSION',
  PROFESSION_LIST = '@profession/LIST',
  PROFESSION_LIST_SUCCESS = '@profession/LIST_SUCCESS',
  PROFESSION_LIST_FAILED = '@profession/LIST_FAILED',
}
